// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginPage_root__3w3L2","form":"LoginPage_form__2cto8","forgotPassword":"LoginPage_forgotPassword__3RJ1y"};